import MainCard from "components/MainCard";
import React, { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import StatusChip from "./StatusChip";
import AirQualityIndexGraphs from "../chart/AirQualityIndexGraphs";
import PowerOperationRateGraph from "../chart/PowerOperationRateGraph";

const StatusStatusTab = ({info, measurementLogsLatest}) => {
    const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();
    
    const { t } = useTranslation();

    const opModeName = useMemo(()=>{
        if (info.latestEquipmentOp?.opMode?.integratedName === 'Cooling') {
            return t('message.common.text.opmode.cooling');
        } else if (info.latestEquipmentOp?.opMode?.integratedName === 'Heating') {
            return t('message.common.text.opmode.heating');
        } else if ((info.equipmentCtgr.parent.parent.code === 'EV' || info.equipmentCtgr.parent.parent.code === 'ES'
                    || info.equipmentCtgr.code.startsWith('DOUBLE.') || info.equipmentCtgr.code.startsWith('SINGLE.')
                    || info.equipmentCtgr.code.startsWith('GEARED.') || info.equipmentCtgr.code.startsWith('GEARLESS.'))
                     && info.latestEquipmentOp?.opMode?.integratedName) {
            return info.latestEquipmentOp?.opMode?.integratedName;
        }
    },[info.latestEquipmentOp?.opMode?.integratedName]);

    // const [tab, setTab] = useState(0); 
    if (!measurementLogsLatest?.length) return null;
    return (
        <div className='alert_phrase' style={{padding:"10px 10px"}}>
            <div style={{marginBottom:"10px"}}><AirQualityIndexGraphs infoId={info?.id} /></div>
            {/* {info?.equipmentCtgr?.parent?.parent?.code === 'AHU' && <div><PowerOperationRateGraph infoId={info?.id} /></div>} */}
            {info?.equipmentCtgr?.parent?.parent?.code === 'AHU' && timezone !== ('Asia/Shanghai').toLowerCase() &&
                <div><PowerOperationRateGraph infoId={info?.id} /></div>
            }
            {/* <div>예상수명</div>
            <div>진동량 안좋은 순의 진동그래프</div> */}
            {/* <div style={{padding:"10px 20px"}}>
                <p className="statustab0" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${tab === 0 ? "3px solid #0061d0": "unset"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{setTab(0)}}>{'공기질지수 그래프'}</p>
                <p className="statustab1" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${tab === 1 ? "3px solid #0061d0": "unset"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{setTab(1)}}>{'전력사용량 추이'}</p>
                <p className="statustab2" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${tab === 2 ? "3px solid #0061d0": "unset"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{setTab(2)}}>{'예상수명'}</p>
                <p className="statustab3" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${tab === 3 ? "3px solid #0061d0": "unset"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{setTab(3)}}>{'진동량 안좋은 순의 진동그래프'}</p>
            </div>

            <div className="tab_table_in1">
                <MainCard className="center_table" content={false}>
                    {tab === '0' && <div>공기질지수 그래프</div>}
                    {tab === '1' && <div>전력사용량 추이</div>}
                    {tab === '2' && <div>예상수명</div>}
                    {tab === '3' && <div>진동량 안좋은 순의 진동그래프</div>}
                </MainCard>
            </div> */}
            <StatusChip measurementLogsLatest={measurementLogsLatest} opMode={opModeName} />
        </div>
    )
}

export default StatusStatusTab;